import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import { Helmet } from "react-helmet";
import Loader from "../../../components/Loader";
import { useStripe } from "@stripe/react-stripe-js";

const ConnectBank = ({ match, props }) => {
    const { str } = match?.params;
    const redirect = useHistory();
    const stripe = useStripe();
    const [loading, setLoading] = useState(true);

    const redirectApp = (deepLink) => {
        window.location.href = deepLink;
    }

    useEffect(() => {
        const fetchByID = async () => {
            await axios.get(process.env.REACT_APP_TENANT_API_URL + 'v1/create-fc-session/' + str).then(response => {
                const resData = response.data;
                if (resData?.secret_session !== '') {
                    setLoading(false);
                    stripe.collectFinancialConnectionsAccounts({
                        clientSecret: resData?.secret_session
                    }).then(async (result) => {
                        if (result.error) {
                            redirectApp(process.env.REACT_APP_APP_DEEPLINK + '://new-payment?status=fail');
                        } else if (result.financialConnectionsSession.accounts.length === 0) {
                            redirectApp(process.env.REACT_APP_APP_DEEPLINK + '://new-payment?status=fail');
                        } else {
                            let accounts = result.financialConnectionsSession.accounts;
                            if (accounts.length > 0) {
                                let accountObjArr = [];
                                for (let n in accounts) {
                                    let account = accounts[n];
                                    accountObjArr.push({ 'fc_account_id': account['id'], 'display_name': account['display_name'], 'institution_name': account['institution_name'], 'last4': account['last4'], 'category': account['category'] });
                                }

                                await axios.post(process.env.REACT_APP_TENANT_API_URL + 'v1/add-fc-account', { 'accountObjArr': JSON.stringify(accountObjArr), 'verify_url_token': str }).then(response => {
                                    if (response.data.status === 'connected') {
                                        redirectApp(process.env.REACT_APP_APP_DEEPLINK + '://new-payment?status=success');
                                    } else {
                                        redirectApp(process.env.REACT_APP_APP_DEEPLINK + '://new-payment?status=fail');
                                    }
                                }).catch(error => {
                                    redirectApp(process.env.REACT_APP_APP_DEEPLINK + '://new-payment?status=fail');
                                });
                            }
                        }
                    });
                } else {
                    redirectApp(process.env.REACT_APP_APP_DEEPLINK + '://new-payment?status=fail');
                }
            }).catch(error => {
                redirectApp(process.env.REACT_APP_APP_DEEPLINK + '://new-payment?status=fail');
            });
        }
        if (str !== '' && stripe) {
            fetchByID();
        }
    }, [str, redirect, stripe]);

    return (<React.Fragment>
        <Helmet title="Connect Your Bank Account" />
        {loading && <Loader />}
    </React.Fragment>);
}

export default ConnectBank;